import { z } from 'zod';

export enum RouteStatus {
  CREATED = 'CREATED',
  START_DELIVERY = 'START_DELIVERY',
  CANCELED = 'CANCELED',
  ALL_WAYPOINTS_FINISHED = 'ALL_WAYPOINTS_FINISHED',
  FINISHED = 'FINISHED',
}

export enum RouteType {
  CARRIER = 'CARRIER',
  PRIVATE_FLEET = 'PRIVATE-FLEET',
  NONE = 'NONE',
}

/**
 * `routes.metadata.cancellation`, gravado pelo carrier-integrations quando a
 * rota é cancelada. Campos frouxos de propósito: o `routeSchema.parse` roda em
 * cada linha da lista (menu de ações), e um valor inesperado aqui não pode
 * derrubar a linha.
 */
export const routeCancellationSchema = z.object({
  canceled_at: z.string().optional().nullable(),
  cancelled_by_user_id: z.string().optional().nullable(),
  source: z.string().optional().nullable(),
  completed_orders: z.number().optional().nullable(),
  canceled_orders: z.number().optional().nullable(),
});

export type RouteCancellation = z.infer<typeof routeCancellationSchema>;

export const routeSchema = z.object({
  all_waypoints_finished_at: z.string().optional().nullable(),
  app_version: z.string().optional().nullable(),
  canceled_at: z.string().optional().nullable(),
  type: z.string(),
  carrier_name: z.string().optional().nullable(),
  carrier_integration: z.any(),
  created_at: z.string(),
  deliveries: z.array(z.any()),
  driver: z
    .object({
      id: z.string(),
      first_name: z.string(),
      last_name: z.string(),
      document_number: z.string(),
    })
    .nullable(),
  expected_meters: z.number().nullable(),
  expected_minutes: z.number().nullable(),
  external_id: z.any(),
  external_name: z.string(),
  finished_at: z.string().optional().nullable(),
  id: z.any(),
  integration_id: z.string().optional().nullable(),
  method_type: z.string().optional().nullable(),
  name: z.string(),
  provider: z.string(),
  started_at: z.string().optional().nullable(),
  status: z.string(),
  route_created_at: z.string().optional().nullable(),
  route_started_at: z.string().optional().nullable(),
  created_by_user_id: z.string().optional().nullable(),
  created_by_user: z
    .object({
      email: z.string(),
    })
    .optional()
    .nullable(),
  cancelled_by_user_id: z.string().optional().nullable(),
  cancelled_by_user: z
    .object({
      email: z.string(),
    })
    .optional()
    .nullable(),
  route_requested_by_user_id: z.string().optional().nullable(),
  route_requested_by_user: z
    .object({
      email: z.string(),
    })
    .optional()
    .nullable(),
  polyline: z
    .object({
      id: z.string(),
      polyline: z.string(),
    })
    .optional(),
  start_location: z.any().nullable(),
  end_location: z.any().nullable(),
  latitude: z.number().optional().nullable(),
  longitude: z.number().optional().nullable(),
  last_location_update_at: z.string().optional().nullable(),
  end_location_id: z.string().nullable(),
  start_warehouse_id: z.string().nullable(),
  cost: z.number().optional().nullable(),
  final_cost: z.number().optional().nullable(),
  route_tags: z
    .array(
      z.object({
        id: z.string(),
        label: z.string(),
        color: z.string(),
        description: z.string().optional().nullable(),
      }),
    )
    .optional()
    .nullable(),
  cancellation: routeCancellationSchema.optional().nullable(),
});

export type Route = z.infer<typeof routeSchema>;
